import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
import Global from '../../../customlib/Global';
class UrlIklanMobile extends Component {
    state = { } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"URL Iklan"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}></Filter>
                    <Grid container spacing={1}>
                        <Grid item xs={6} textAlign={"center"}><strong>Total Acquisition</strong></Grid>
                        <Grid item xs={6} textAlign={"center"}><strong>Total Retention</strong></Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={6} textAlign={"center"} sx={{fontSize: "20px"}}>{this.props.totalAllAcquisition}</Grid>
                        <Grid item xs={6} textAlign={"center"} sx={{fontSize: "20px"}}>{this.props.totalAllRetention}</Grid>
                    </Grid>
                    {
                    this.props.contactLeadsHourly?.map((leadGroup, index) => {
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <Typography component="span">{leadGroup.label}</Typography>
                                        </Grid>
                                        <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.count} leads
                                        </Grid>
                                        <Grid item xs={6} textAlign={"left"} sx={{pr: "5px"}}>
                                            {leadGroup.countAcquisition} Acquisition
                                        </Grid>
                                        <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.countRetention} Retention
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        leadGroup.detail.map((lead, indexLeads) => {
                                            return (
                                                <Paper elevation={0} sx={{mb: "10px", padding: "5px"}} key={`itemleads-${indexLeads}`}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Kota</Typography>
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.city}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Pelanggan</Typography>
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.customer_name}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Tipe</Typography>
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.is_tele_customer ? "RETENTION" : "ACQUISITION"}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Kategori</Typography>
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.product_category}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Waktu</Typography>
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {Global.formatDateTimeToStrTime24(lead.created_at)}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">URL</Typography>
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {
                                                                lead.extracted_urls.map((item, index) => {
                                                                    return <Button variant='outlined' size='small' target='_blank' rel="noreferrer" href={item}>{`Link ${index+1}`}</Button>;
                                                                })
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Paper>
                                            );
                                        })
                                    }
                                    
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default UrlIklanMobile;